import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    nonseating: Boolean,
  };
  connect() {
    // 非連席がどうかの判定を行う
    if (this.nonseatingValue) {
      // モーダルを表示する
      document.getElementById("SeatingAlertTrigger").click();
    }
  }

  cancel() {
    // キャンセルボタンが押された場合の処理
    document.getElementById("NonseatingAlertCancel").click();
  }
}
